import { Component, ElementRef, EventEmitter, HostListener, Output } from '@angular/core';
import { ButtonConfiguaration } from '../../models/navigation-tabI';
export interface PopupModel {
  isVisible: boolean;
  title: string;
  generateButtonConfig: ButtonConfiguaration;
  uploadedButtonConfig: ButtonConfiguaration;
  positionX?: string;
  positionY?: string;
}

@Component({
  selector: 'app-volume-forecasting-custom-popup',
  template: `
    <div class="popup" *ngIf="popupModel.isVisible" [style.left]="popupModel.positionX" [style.top]="popupModel.positionY">
  <div>
    <h3 (click)="onGeneratedVolumeForecastingFileClick()">{{ popupModel.generateButtonConfig.text }}</h3>
  </div>
  <div>
    <h3 (click)="onUploadedVolumeForecastingFileClick()">{{ popupModel.uploadedButtonConfig.text }}</h3>
  </div>
</div>

  `,
  styles: [`
         .popup {
          display: flex;
    flex-direction: column;
    position: absolute;
    gap: 5px;
    /* top: 50%; */
    /* left: 83%; */
    transform: translate(-25%, -50%);
    background: white;
    border: 1px solid black;
    padding: 10px 14px 3px 15px;;
    z-index: 1000;
    border-radius: 8px;
    h3{
      font-size:18px;
      cursor: pointer;
      }
    }

    `]
})
export class VolumeForeactingCustomPopupComponent {
  constructor(private elementRef: ElementRef) { }

  popupModel: PopupModel = {
    isVisible: false,
    title: 'Choose an option',
    generateButtonConfig: {
      text: 'Generated file',
      buttonType: 'primary',
      imageUrl: '',
      linkURL: ''
    },
    uploadedButtonConfig: {
      text: 'Uploaded file',
      buttonType: 'primary',
      imageUrl: '',
      linkURL: ''
    }
  };

  @Output() generatedVlFileClick = new EventEmitter<void>();
  @Output() uploadedVlFileClick = new EventEmitter<void>();
  @Output() closeClick = new EventEmitter<void>();

  public documentClickListener: any;

  show(event: MouseEvent) {
    const h3 = event.target as HTMLElement;
    const rect = h3.getBoundingClientRect();

    // Calculate the position relative to the button
    const posX = rect.left + window.scrollX - 64 ; // Slightly to the right
    const posY = rect.top + window.scrollY + h3.offsetHeight + 50; // Below the button

    // Set the position of the popup
    this.popupModel.positionX = posX + 'px';
    this.popupModel.positionY = posY + 'px';

    this.popupModel.isVisible = true;

    // Add a slight delay to prevent the current click event from triggering the close logic
    setTimeout(() => {
      this.documentClickListener = this.onClickOutside.bind(this);
      document.addEventListener('click', this.documentClickListener);
    }, 0);
  }

  closePopup() {
    this.popupModel.isVisible = false;
    document.removeEventListener('click', this.documentClickListener);
    this.closeClick.emit();
  }

  onGeneratedVolumeForecastingFileClick() {
    this.generatedVlFileClick.emit();
  }

  onUploadedVolumeForecastingFileClick() {
    this.uploadedVlFileClick.emit();
  }
  onClickOutside(event: MouseEvent) {
    if (this.popupModel.isVisible && !this.elementRef.nativeElement.contains(event.target)) {
      this.closePopup();
    }
  }
}
